exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success-icon[data-v-aab1791c]{display:inline-flex;width:1.8461538462em;height:1.8461538462em;align-items:center;justify-content:center;background-color:#ffa014;border-radius:50%}.success-icon__char[data-v-aab1791c]{color:#fff;font-size:1.2307692308em}", ""]);

// exports
